module.exports = __webpack_public_path__ + "static/media/reflive.c32d2f3c.svg";